@use 'src/globals/main';

pn-segment {
  position: relative;
  color: main.$blue700;
  margin-right: 0.5em;
  z-index: 2;
  white-space: nowrap;
  scroll-snap-align: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);

  &:last-of-type {
    margin-right: 0;
  }
}

pn-segment .pn-segment {
  cursor: pointer;
  margin: 0;
  padding: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: transparent;

  &:disabled {
    cursor: not-allowed;
    ~ .pn-segment-label {
      color: main.$gray700;
      pn-icon .pn-icon-svg path {
        fill: main.$gray700;
      }
    }
  }

  &-label {
    height: 100%;
    width: 100%;
    padding: 0.5em;
    border-radius: 3em;
    font-weight: 500;
    border: 0.0625em solid transparent;

    display: inline-flex;
    gap: 0.5em;
    align-items: center;

    -webkit-tap-highlight-color: transparent;

    pn-icon .pn-icon-svg path {
      @include main.pn-transition('fill');
    }
  }
}
